import { GetUsersWithLoginDataDocument } from '@/generated/graphql';
import { useQuery } from '@vue/apollo-composable';
import { computed, Ref, ref, watch } from 'vue';
import { MappedUser, mapUsers } from '../user';

const users: Ref<MappedUser[] | undefined> = ref();

export function useUserList() {
    const { result, loading } = useQuery(GetUsersWithLoginDataDocument);

    watch(
        result,
        (value) => {
            if (value) {
                users.value = mapUsers(value);
            }
        },
        { immediate: true },
    );

    const userCount = computed(() => users.value?.length);

    function updateUsers(usersUpdate: MappedUser[]) {
        users.value = usersUpdate;
    }

    return {
        users,
        loading,
        userCount,
        updateUsers,
    };
}
